module.exports = __webpack_public_path__ + "img/spg.a2c42586.svg";